"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var findIndex_1 = tslib_1.__importDefault(require("lodash/findIndex"));
var TYPES = tslib_1.__importStar(require("./action-types"));
var filterOutError = function (errors, fetchingError) {
    if (findIndex_1.default(errors, function (e) { return e.error === fetchingError; }) === -1) {
        return errors;
    }
    return errors.filter(function (error) { return error.error !== fetchingError; });
};
exports.ROOT_KEY = 'data';
/*******************************************************************************
 *  Default State
 */
exports.DEFAULT_STATE = {
    fetching: {},
    fetched: {},
    fetchingErrors: []
};
/*******************************************************************************
 *  Reducers
 */
function dataReducer(state, action) {
    if (state === void 0) { state = exports.DEFAULT_STATE; }
    var errors = state.fetchingErrors || [];
    /*
     * our fetchType is the action type that was passed in one of our fetch utils
     */
    var fetchType = action.fetching || action.fetched || action.fetchingError;
    /*
     * helper function that updates our fetching object
     */
    var fetching = function (bool) {
        var _a;
        return Object.assign({}, state.fetching, (_a = {}, _a[fetchType] = bool, _a));
    };
    /*
     * helper function that updates our fetched object
     */
    var fetched = function (bool) {
        var _a;
        return Object.assign({}, state.fetched, (_a = {}, _a[fetchType] = bool, _a));
    };
    switch (action.type) {
        case TYPES.FETCHING:
            return tslib_1.__assign({}, state, { fetching: fetching(true), fetched: fetched(false), fetchingErrors: filterOutError(errors, action.fetching) });
        case TYPES.FETCHED:
            return tslib_1.__assign({}, state, { fetched: fetched(true), fetching: fetching(false) });
        case TYPES.RESET_FETCHED:
            return tslib_1.__assign({}, state, { fetched: fetched(false), fetching: fetching(false) });
        case TYPES.FETCHING_ERROR:
            return tslib_1.__assign({}, state, { fetchingErrors: tslib_1.__spread(errors, [{
                        error: action.fetchingError,
                        message: action.message,
                        results: action.results
                    }]), fetched: fetched(false), fetching: fetching(false) });
        case TYPES.REMOVE_FETCHING_ERROR:
            return tslib_1.__assign({}, state, { fetchingErrors: filterOutError(errors, action.fetchingError) });
        default:
            return state;
    }
}
exports.default = dataReducer;
//# sourceMappingURL=reducers.js.map